import React from "react";

const RedirectButton = (props) => {
  const buttonHandler = () => {
    props.history.push("/");
  };

  return (
    <div className="mt-32">
      <button
        onClick={buttonHandler}
        className="text-white text-xl font-bold py-2 px-4 rounded  w-1/5 text-center h-16 narrativeGradient"
      >
        <span className="graphikFont">Try Again</span>
      </button>
    </div>
  );
};

export default RedirectButton;
